import React, {Component} from "react";
import {connect} from 'react-redux'
import PostComponent from "../components/PostComponent";
import * as LoanAPI from "../utils/api/loanAPI";
import {withAuth0} from "@auth0/auth0-react";
import {createUserRequest} from "../redux/actions/request";
import {createUserProposal} from "../redux/actions/proposal";
import {Alert, AlertTitle} from "@mui/material";
import Button from "@mui/material/Button";
import {errorCleared, errorOccurred} from "../redux/actions/error";

class PostContainer extends Component{
    state = {
        availableAmounts: [],
        unavailableAmounts:[],
        allAmounts: [],
        title:"",
        amount:0,
        length:1,
        comment:"",
        rate:1,
        payment:0,
        profit:0,
        minScore:0,
        maxScore:1500000,
        idVerified: false,
        addressVerified: false,
        incomeVerified: false,
        isConnected: false,
        fee: 0,
        totalDue: 0,
        postedBalance: 0,
        image:null,
    }
    componentDidMount() {
        this.retrieveToken()
            .then(token=>{
                LoanAPI.getUserQualifiedAmount(token).then((amounts)=>{
                    this.setState(
                        {
                            availableAmounts: amounts["available"],
                            unavailableAmounts: amounts["unavailable"],
                            allAmounts: amounts["all_amount"]
                        }
                    )
                })
            })
    }
    handleChange = (e, field) =>{
        this.setState({
            [field]: e.target.files?e.target.files[0]:e.target.value
        })
        if (field !== "comment" && field!== "title"){
            if (this.state.amount > 0 && this.state.rate > 0 && this.state.length >= 1){
                this.retrieveToken()
                    .then(token=>{
                        LoanAPI.calculateLoanPayment(token, Math.round(this.state.length), this.state.rate, this.state.amount)
                            .then(r=>{
                                this.setState({
                                    profit: r.profit,
                                    payment: r.minPayment,
                                    fee: r.fee,
                                    totalDue: r.totalDue,
                                    postedBalance: r.balance
                                })
                            })
                    })
            }
            else {
                this.setState({
                    profit: 0,
                    payment: 0,
                    fee: 0,
                    totalDue: 0
                })
            }
        }
    }
    handleRequestSubmit = ()=>{
        const {amount, length, comment, title} = this.state
        const request = {
            title,
            amount,
            length,
            comment
        }
        if (this.state.image != null){
            request["image"] = this.state.image
        }
        if (request.length >= 1 && request.amount >= 50 && request.title.length > 0){
            this.retrieveToken()
                .then(token=>{
                    this.props.dispatch(createUserRequest(token,request))
                })
        }
        else {
            this.props.dispatch(errorOccurred({"detail": "Make sure that all fields are valid"}))
        }

    }

    handleProposalSubmit = ()=>{
        const propose = {
            title: this.state.title,
            amount: this.state.amount,
            length: this.state.length,
            rate: this.state.rate,
            minScore: this.state.minScore,
            maxScore: this.state.maxScore,
            comment: this.state.comment,
            idVerified: this.state.idVerified,
            addressVerified: this.state.addressVerified,
            incomeVerified: this.state.incomeVerified,
            isConnected: this.state.isConnected
        }
        if (this.state.image != null){
            propose["image"] = this.state.image
        }
        if (propose.rate > 0 && propose.length >=1 && propose.title.length >1){
            this.retrieveToken()
                .then(token=>{
                    this.props.dispatch(createUserProposal(token,propose))
                })
        }
        else {
            this.props.dispatch(errorOccurred({"detail": "Make sure that all fields are valid"}))
        }

    }
    async retrieveToken(){
        const {getAccessTokenSilently} = this.props.auth0
        let accessToken;
        try{
            accessToken = await getAccessTokenSilently()
        }catch (e){
            console.error(e);
        }
        return accessToken;
    }

    handleCLoseError = ()=>{
        this.props.dispatch(errorCleared())
    }
    render() {
        const requestValues = {
            availableAmounts: this.state.availableAmounts,
            allAmounts: this.state.allAmounts,
            amount:this.state.amount,
            title:this.state.title,
            length: this.state.length,
            comment: this.state.comment,
            image: this.state.image,
            rate:this.state.rate,
            payment: this.state.payment,
            profit: this.state.profit,
            minScore: this.state.minScore,
            maxScore: this.state.maxScore,
            idVerified: this.state.idVerified,
            addressVerified: this.state.addressVerified,
            incomeVerified: this.state.incomeVerified,
            isConnected: this.state.isConnected,
            fee: this.state.fee,
            postedBalance: this.state.postedBalance,
            totalDue: this.state.totalDue
        }
        const {error} = this.props
        return(
            <>
                <PostComponent
                    profile={this.props.profile}
                    propsRequestValues={requestValues}
                    onChangeValue={this.handleChange}
                    handleRequestSubmit={this.handleRequestSubmit}
                    handleProposalSubmit={this.handleProposalSubmit}
                />
                {error!==null?
                    <>
                        {Object.keys(error).length > 0?
                            <Alert
                                severity="error"
                                action={
                                    <Button onClick={this.handleCLoseError} color="inherit" size="small">
                                        Dismiss
                                    </Button>
                                }
                            >
                                <AlertTitle>Error</AlertTitle>
                                {error.detail} <strong></strong>
                            </Alert>:<></>
                        }
                    </>:<></>
                }
            </>


        )
    }
}

function mapStateToProps({authedUser, error}){
    let errorObject = {}
    if (Object.keys(error).length > 0){
        errorObject = error.error
    }
    return {
        profile :authedUser,
        error: errorObject
    }
}

export default connect(mapStateToProps)(withAuth0(PostContainer))